/**
 * Sicherheitsfix (intensiver Security-Check, siehe Chat): `Landing.tsx` nahm
 * den `?weiter=`-Parameter aus der URL bisher UNGEPRÜFT und reichte ihn direkt
 * an `<Navigate to={...}>` weiter — ein klassischer offener Redirect. Ein
 * Angriffslink wie
 *   https://guenni-eis.de/?weiter=https%3A%2F%2Fboese-seite.de
 * hätte einen frisch angemeldeten Nutzer nach dem (echten!) Login auf eine
 * beliebige externe Seite umgeleitet — ideal fürs Nachladen eines Phishing-
 * Formulars, weil die Anmeldung selbst auf der echten Domain stattfand.
 *
 * Verschärfend: `npm audit` zeigt für die installierte react-router-Version
 * (6.30.6, Bereich 6.0.0–7.17.0 betroffen) eine bekannte Schwachstelle genau
 * dafür — ein Open-Redirect-Bypass über führende Backslashes in <Link>/
 * useNavigate (`//böse.de`, `/\böse.de` u. Ä. werden von Browsern teils wie
 * ein protokoll-relativer Link behandelt). Ein Bibliotheks-Update behebt die
 * Library-Seite; diese Prüfung schließt die Lücke unabhängig davon, welche
 * Version installiert ist — sie lässt von vornherein nur echte, interne,
 * relative Pfade durch.
 */
export function sichererWeiterPfad(weiter: string | null | undefined): string {
  const FALLBACK = '/app';
  if (!weiter) return FALLBACK;
  // Genau ein führender Schrägstrich (sonst z. B. "evil.de" ohne führenden
  // Slash oder eine absolute URL "https://evil.de").
  if (!weiter.startsWith('/')) return FALLBACK;
  // Ein zweites "/" oder ein "\" direkt danach macht daraus einen
  // protokoll-relativen bzw. (per Browser-Normalisierung) absoluten Link
  // ("//evil.de", "/\evil.de", "/\/evil.de" ...).
  if (/^\/[/\\]/.test(weiter)) return FALLBACK;
  // Zusätzliche Absicherung: keine eingebettete Protokoll-Angabe irgendwo im Pfad.
  if (weiter.includes('://')) return FALLBACK;
  return weiter;
}
